import { AchDraft, CheckDraft, HistoryFilter } from './types';

export const ACCOUNT_TYPES = ['Checking', 'Savings'];

export const INITIAL_ACH: AchDraft = {
  accountHolderName: '',
  accountType: '',
  routingNumber: '',
  accountNumber: '',
};

export const INITIAL_CHECK: CheckDraft = {
  line1: '',
  line2: '',
  city: '',
  state: '',
  zip: '',
  phone: '',
};

export const HISTORY_FILTER_OPTIONS: { value: HistoryFilter; label: string }[] = [
  { value: 'ALL', label: 'All Changes' },
  { value: 'ACH', label: 'ACH Details' },
  { value: 'CHECK', label: 'Mailing Address' },
];
